import {Flash} from '@primer/react'

import styles from './EditingForkBanner.module.css'

export function EditingForkBanner({forkName, forkOwner}: {forkName: string; forkOwner: string}) {
  return (
    <Flash aria-live="polite" className={styles.Flash}>
      You’re making changes in a project you don’t have write access to. Submitting a change will write it to a new
      branch in your fork <b>{`${forkOwner}/${forkName}`}</b>, so you can send a pull request.
    </Flash>
  )
}

try{ EditingForkBanner.displayName ||= 'EditingForkBanner' } catch {}